import { AwaitableEvent } from "UI/UI.BaseControls/AwaitableEvent";
import { IOrderBy } from "../../Global/Base/DataSources/Interfaces";

export class DataGridSharedMethods {
    /**
     * Vraci index polozky orderby s danym attrName nebo vraci -1
     * @param attrName
     */
    public static orderByIndexOf(orderBy: IOrderBy[], attrName: string): number {
        if (orderBy == null || attrName == null)
            return -1;

        for (let i: number = 0; i < orderBy.length; i++) {
            if (orderBy[i].attributeName.toLowerCase() == attrName.toLowerCase())
                return i;
        }

        return -1;
    }

    /**
     * Čeká na potvrzení od uživatele při rozeditovaném formu, zda je možné provést změnu řádku
     * @param element Element, který vyvolává událost, na kterou lze čekat
     * @param selectAll (Nepovinný) Příznak, zda je změna označení řádku na "vybrat vše"
     */
    public static async canChangeSelectedRow(element: HTMLElement, selectAll?: boolean): Promise<boolean> {
        const eventData = new AwaitableEvent("SelectionChangedPreview", true, { bubbles: true, detail: { selectAll: selectAll } });

        element.dispatchEvent(eventData); // musí být dispatch místo vlastní helper metody callEvent

        return await eventData.resultAwaiter;
    }
}
